import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ContentChild
} from '@angular/core';

@Component({
  selector: 'iq-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  host: { class: 'iq-error-message' }
})
export class ErrorMessageComponent implements OnInit {
  private _errorMessage: string;

  @ContentChild('content')
  content: ElementRef;

  @Input()
  public get errorMessage() {
    return this._errorMessage;
  }

  public set errorMessage(val: string) {
    this._errorMessage = val;
  }

  constructor() {}

  ngOnInit() {}
}
